import React, { useEffect, useState } from "react";
import ListHeader from "../../../components/listing/ListHeader";
import ListFooter from "../../../components/listing/ListFooter";
import DynamicTable from "../../../components/listing/DynamicTable";
import FiltroMarca from "./FiltroMarca";
import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";
import IconEdit from "../../../components/icons/IconEdit";
import IconTrash from "../../../components/icons/IconTrash";
import CrearMarca from "./CrearMarca";
import EditarMarca from "./EditarMarca";
import EliminarMarca from "./EliminarMarca";

export default function ListarMarca() {
  const [porPagina, setPorPagina] = useState(30);
  const [pagina, setPagina] = useState(1);
  const [totalBackend, setTotalBackend] = useState(0);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [reloadKey, setReloadKey] = useState(0);
  const [mostrarCrear, setMostrarCrear] = useState(false);
  const [marcaAEditar, setMarcaAEditar] = useState(null);
  const [marcaAEliminar, setMarcaAEliminar] = useState(null);
  const [mostrarFiltros, setMostrarFiltros] = useState(false);
  const [filtros, setFiltros] = useState({ descricao: "" });

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const url = apiRoutes.marcas.listUrl({
          page: pagina - 1,
          size: porPagina,
          descricao: filtros.descricao.trim() || undefined,
        });

        const res = await appFetchJson(url);
        const items = Array.isArray(res?.items) ? res.items : [];
        setData(items);
        setTotalBackend(res?.totalElements ?? res?.total ?? items.length);
      } catch (e) {
        console.error("Error cargando marcas:", e);
        setError("Error al cargar las marcas.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [pagina, porPagina, filtros, reloadKey]);

  const columns = [
    {
      header: "Descripción",
      accessor: "descricao",
      type: "text",
      width: "80%",
      cellClass: "font-medium text-gray-800 break-words",
    },
    {
      header: "Acción",
      type: "action",
      width: "20%",
      render: (row) => (
        <div className="flex justify-center items-center gap-2">
          <button title="Editar" onClick={() => setMarcaAEditar(row)}>
            <IconEdit />
          </button>
          <button title="Eliminar" onClick={() => setMarcaAEliminar(row)}>
            <IconTrash />
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="page">
      <ListHeader
        title="Marcas"
        filters={filtros}
        onFilterClick={() => setMostrarFiltros(true)}
        onClearFilters={() => {
          setFiltros({ descricao: "" });
          setPagina(1);
        }}
        showAdd={true}
        addLabel="Agregar"
        onAddClick={() => setMostrarCrear(true)}
        pageSize={porPagina}
        onPageSizeChange={(size) => {
          setPorPagina(size);
          setPagina(1);
        }}
      />

      {loading && <div className="mt-2 text-sm text-gray-600">Cargando datos...</div>}
      {error && <div className="mt-2 text-sm text-red-600">{error}</div>}

      {mostrarFiltros && (
        <FiltroMarca
          initialFilters={filtros}
          onSubmit={(nuevos) => {
            setFiltros(nuevos);
            setPagina(1);
            setMostrarFiltros(false);
          }}
          onClose={() => setMostrarFiltros(false)}
        />
      )}

      <DynamicTable size="S" data={data} columns={columns} />

      <ListFooter
        page={pagina}
        pageSize={porPagina}
        total={totalBackend}
        onPageChange={(p) => setPagina(p)}
      />

      {mostrarCrear && (
        <CrearMarca
          onClose={() => setMostrarCrear(false)}
          onCreated={() => {
            setPagina(1);
            setReloadKey((k) => k + 1);
            setMostrarCrear(false);
          }}
        />
      )}

      {marcaAEditar && (
        <EditarMarca
          initial={marcaAEditar}
          onClose={() => setMarcaAEditar(null)}
          onSaved={() => {
            setReloadKey((k) => k + 1);
            setMarcaAEditar(null);
          }}
        />
      )}

      {marcaAEliminar && (
        <div className="modal-backdrop" onClick={() => setMarcaAEliminar(null)}>
          <div className="modal-panel-md" onClick={(e) => e.stopPropagation()}>
            <EliminarMarca
              registro={marcaAEliminar}
              onClose={() => setMarcaAEliminar(null)}
              onDeleted={() => {
                setReloadKey((k) => k + 1);
                setMarcaAEliminar(null);
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
}